import { Component, Input, OnChanges } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { TranslateService } from '@ngx-translate/core';
import { CollectsTrendPoint } from '../../../../services/collects-analytics/collects-analytics.model';

@Component({
    selector: 'app-collects-views-trend',
    templateUrl: './collects-views-trend.component.html',
    styleUrls: ['./collects-views-trend.component.scss'],
})
export class CollectsViewsTrendComponent implements OnChanges {
    @Input() currentData: CollectsTrendPoint[] = [];
    @Input() previousData: CollectsTrendPoint[];

    chartData: ChartConfiguration<'line'>['data'] = { labels: [], datasets: [] };

    chartOptions: ChartConfiguration<'line'>['options'] = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: 'bottom', labels: { boxWidth: 12, padding: 16 } },
        },
        scales: {
            x: { grid: { display: false } },
            y: { beginAtZero: true, ticks: { precision: 0 } },
        },
        elements: {
            point: { radius: 3, hoverRadius: 5 },
            line: { tension: 0.3 },
        },
    };

    constructor(private translate: TranslateService) {}

    ngOnChanges(): void {
        if (!this.currentData || this.currentData.length === 0) return;

        const labels = this.currentData.map((p) => this.formatDate(p.date));
        const datasets: ChartConfiguration<'line'>['data']['datasets'] = [
            {
                label: this.translate.instant('pages.collections.analytics.current_period'),
                data: this.currentData.map((p) => p.count),
                borderColor: '#3a7bd5',
                backgroundColor: '#3a7bd520',
                pointBackgroundColor: '#3a7bd5',
                pointBorderColor: '#3a7bd5',
                fill: true,
            },
        ];

        if (this.previousData && this.previousData.length > 0) {
            datasets.push({
                label: this.translate.instant('pages.collections.analytics.previous_period'),
                data: this.previousData.map((p) => p.count),
                borderColor: '#d1d5db',
                backgroundColor: 'transparent',
                pointBackgroundColor: '#d1d5db',
                pointBorderColor: '#d1d5db',
                borderDash: [5, 5],
                fill: false,
            });
        }

        this.chartData = { labels, datasets };
    }

    private formatDate(dateStr: string): string {
        if (dateStr.includes('W')) return dateStr;
        const date = new Date(dateStr + 'T00:00:00');
        return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
    }
}
